module.exports = __webpack_public_path__ + "static/media/mchERP.8712ad09.png";